export default "__VITE_ASSET__CIctBh1r__"